<template>
    <div class="appConfig">
        <div class="tabWrap">
            <span :class="{'selected':selectIndex===index}" v-for="(item,index) in tabArr" :key="item.id"
                  @click="tabSwitch(index,item.id)">{{item.name}}</span>
        </div>
        <div class="listWrap">
            <div v-for="(item,index) in appArr" :key="item.id" class="column">
                <div class="imgWrap"><img :src="item.icon||require('../../assets/images/app_first.png')"></div>
                <div class="infoWrap">
                    <div class="name">
                        <span>{{item.name}}</span>
                        <span class="btn" v-if=" item.def6==='0' " @click="subscribe(item.id)">订阅应用</span>
                        <span class="btn hasSub" v-else @click="cancleSubscribe(item.id)">已订阅</span>
                    </div>
                    <div class="category">{{item.tag||'暂无标签'}}</div>
                    <div class="brief">{{item.description||'暂无详细描述'}}</div>
                </div>
            </div>
            <div v-show="showEmpty" class="empty">该分类暂无数据</div>
        </div>
        <Pagenation :pageparams="pageDefault" @handlePage="getPageList" :itemList="tabArr"/>
    </div>
</template>

<script>
    import Pagenation from '../../components/pagenation';
    import api from '../../api/appConfiguration/index';
    import {objToStr} from "../../utils/auth";

    export default {
        name: "appConfiguration",
        components: {
            Pagenation
        },
        data() {
            return {
                pageDefault: {
                    total: 0,
                    page: 1,
                    pageSize: 8
                },
                queryParams: {//表格查询参数
                    page: 1,
                    rows: 8,
                    pid: '',
                    communityId: this.$store.state.userInfo.communityId
                },
                tabArr: [],
                appArr: [],
                selectIndex: 0,
                showEmpty: false,
            }
        },
        methods: {
            tabSwitch(index, id) {
                this.selectIndex = index;
                this.queryParams.pid = id;
                this.getPageList()
            },
            async getPageList(index) {
                this.queryParams.page = index || 1;
                this.pageDefault.page = index || 1;
                let res = await this.$http.get(api.appList, {params: this.queryParams});
                if (res.isSucceed) {
                    this.pageDefault.total = res.total;
                    this.appArr = [];
                    this.appArr = [...res.rows];
                    if (this.appArr.length > 0) {
                        this.showEmpty = false;
                    } else {
                        this.showEmpty = true;
                    }
                } else {
                    this.$message.error(res.message)
                }
            },
            async getType() {
                let res = await this.$http.get(api.appType);
                if (res.isSucceed) {
                    this.tabArr = [{name: '全部', pid: ''}, ...res.rows]
                } else {
                    this.$message.error(res.message)
                }
            },
            async subscribe(sysResourceId) {
                let params = {
                    communityId: this.$store.state.userInfo.communityId,
                    sysResourceId
                };
                let res = await this.$http.post(api.subscribe, objToStr(params), {loading: true});
                if (res.isSucceed) {
                    this.$message.success('订阅成功');
                    window.postMessage('nav.flush');
                    this.getPageList();
                }

            },
            cancleSubscribe(sysResourceId) {
                this.$confirm('此操作将取消订阅应用, 是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(async () => {
                    let params = {
                        communityId: this.$store.state.userInfo.communityId,
                        sysResourceId
                    };
                    let res = await this.$http.post(api.cancelSubscribe, objToStr(params), {loading: true});
                    if (res.isSucceed) {
                        this.$message.success('取消订阅成功');
                        window.postMessage('nav.flush');
                        this.getPageList();
                    }
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                })
            }
        },
        beforeMount() {
            this.getType();
            this.getPageList();
        }
    }
</script>

<style scoped lang="less">
    .text_overflow {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .appConfig {
        width: 100%;
        height: 100%;
        background: #F5F5F5;
        overflow:auto;
        .empty {
            margin-top: 100px;
            text-align: center;
        }
        .tabWrap {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            width: 100%;
            /*height: 50px;*/
            min-height: 50px;
            max-height: 100px;
            line-height: 30px;
            overflow-y: auto;
            background: #FFFFFF;
            box-shadow: 0 1px 1px #ccc;
            span {
                display: inline-block;
                padding: 0 15px;
                max-width: 120px;
                cursor: pointer;
                font-size: 14px;
                color: #A9B0B4;
                .text_overflow;
                &:hover {
                    color: #757C82;
                    font-weight: bold;
                }
                &.selected {
                    color: #757C82;
                    font-weight: bold;
                }
            }
        }
        .listWrap {
            width: 1100px;
            margin: 15px auto;
            min-height: 640px;
            font-size: 14px;
            .column {
                display: inline-block;
                width: 490px;
                height: 100px;
                padding: 16px;
                background-color: #ffffff;
                border-radius: 4px;
                margin: 12px 8px;
                box-shadow: 0 0 4px 0 rgba(169, 176, 180, 0.20);
                box-sizing: content-box;
                .imgWrap {
                    float: left;
                    img {
                        width: 80px;
                        height: 80px;
                        border-radius: 16px;
                    }
                }
                .infoWrap {
                    float: left;
                    margin-left: 10px;
                    .name {
                        font-size: 16px;
                        color: #323334;
                        text-align: left;
                        line-height: 22px;
                    }
                    .category {
                        margin: 5px 0px;
                        font-size: 12px;
                        color: #A9B0B4;
                        text-align: left;
                        line-height: 14px;
                    }
                    .brief {
                        width: 362px;
                        margin-top: 15px;
                        text-align: left;
                        line-height: 20px;
                        color: #757C82;
                    }
                }
                .btn {
                    display: inline-block;
                    height: 22px;
                    margin-right: -40px;
                    width: 66px;
                    padding: 0 8px;
                    line-height: 22px;
                    background: #38ADFF;
                    text-align: center;
                    float: right;
                    border: 1px solid rgba(0, 0, 0, 0.10);
                    border-radius: 2px;
                    font-size: 12px;
                    color: #FFFFFF;
                    letter-spacing: 0;
                    cursor: pointer;
                    &:hover {
                        color: #f0f0f0;
                    }
                    &.hasSub {
                        background: #009688;
                    }
                }
            }
        }

    }
</style>
